import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import api from "../../services/api";
import Loading from "../../components/Loading";
import { Calendar } from "primereact/calendar";
import Menu from "../../components/Menu";
import { useReport } from "../../context/report";
import { MultiSelect } from "primereact/multiselect";
import ProducaoGeral from "../../components/ProducaoGeral";

export function Geral() {
    const [options, setOptions] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [groupOptions, setGroupOptions] = useState([]);

    const toast = useRef();
    const { data, setData } = useReport();

    const groupedItemTemplate = (option) => {
        return (
            <div className="p-d-flex p-ai-center">
                <Button className="p-button-rounded" label={option.label} onClick={() => {
                    let copy = [...grupos];
                    option.items.forEach(element => {
                        let find = copy.indexOf(element.value);
                        if (find === -1) {
                            copy.push(element.value)
                        } else {
                            copy.splice(find, 1);
                        }
                    });
                    setGrupos(copy);
                }} />
            </div>
        )
    }

    const handleSearch = _ => {
        if (turmas !== null && initialDate !== null && finalDate !== null) {
            let formated1 = initialDate.getFullYear() + "-" + (initialDate.getMonth() + 1) + "-" + initialDate.getDate();
            let formated2 = finalDate.getFullYear() + "-" + (finalDate.getMonth() + 1) + "-" + finalDate.getDate();

            setIsLoading(true);
            api.post("relatorios", {
                tipo: "producaogeral",
                data_inicial: formated1,
                data_final: formated2,
                grupos: grupos,
                turmas: turmas
            }).then((response) => {
                setData(response.data.dados);
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
            });
        } else {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Preencha os campos corretamente para continuar!" });
        }
    }

    useEffect(() => {
        api.get("cadastros/turmas").then((response) => {
            setOptions(response.data);
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });

        api.get('sala').then((response) => {
            let sala = response.data.sala;
            let config = response.data.config;
            
            var grouped = [];
            for (let i = 1; i < config.grupos; i++) {
                let items = [];
                sala.forEach((element) => {
                    if(parseInt(element.grupo) === i) {
                        items.push({
                            label: "T" + element.tear,
                            value: element.tear
                        });
                    }
                });

                grouped.push({
                    label: "Grupo " + i,
                    items: items
                });
            }
            setGroupOptions(grouped)

        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, []);

    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card className="p-m-1" title="Produção Geral">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="turmas">Turmas</label>
                        <MultiSelect
                            onChange={e => setTurmas(e.value)}
                            optionLabel="nome"
                            optionValue="id"
                            options={options}
                            placeholder="Selecione as Turmas"
                            value={turmas}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="grupos">Grupos</label>
                        <MultiSelect
                            optionGroupTemplate={groupedItemTemplate}
                            options={groupOptions}
                            optionGroupLabel="label"
                            optionGroupChildren="items"
                            onChange={e => setGrupos(e.value)}
                            maxSelectedLabels={6}
                            selectedItemsLabel="{0} teares selecionados"
                            placeholder="Selecione os Grupos"
                            value={grupos}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="data_inicial">Data Inicial</label>
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            value={initialDate}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="data_final">Data Final</label>
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            value={finalDate}
                        />
                    </div>
                    <div className="p-field p-col p-as-end">
                        <Button className="p-m-1" icon="pi pi-search" label="Pesquisar" onClick={handleSearch} />
                    </div>
                </div>
                {data && <ProducaoGeral />}
            </Card>
        </div>
    )
}